import { articles } from "@/mocks/content";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import LatestArticles from "./components/LatestArticles";
import HotSidebar from "./components/HotSidebar";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  const latest = [...articles]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 6);
  const hot = [...articles].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <div className="mx-auto max-w-page px-4 py-6 md:px-6 md:py-10">
      <HeroCarousel />

      <div className="mt-10 md:mt-14">
        <div className="mb-5 flex items-end justify-between">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">浏览内容板块</h2>
            <p className="mt-1 text-sm text-foreground-600">从剧情解析到观后延伸，按你的兴趣选一个入口。</p>
          </div>
        </div>
        <CategoryShortcuts />
      </div>

      <div id="content-sections" className="mt-10 grid grid-cols-1 gap-6 md:mt-14 lg:grid-cols-[1fr_320px]">
        <LatestArticles articles={latest} />
        <HotSidebar articles={hot} />
      </div>

      <div className="mt-10 md:mt-14">
        <SiteIntro />
      </div>
    </div>
  );
}